export const handleLoginRememberMe = (rememberMe, token, userObj) => {
  if (rememberMe) {
    localStorage.setItem('jwtToken', token);
    localStorage.setItem('account', JSON.stringify(userObj));
  } else {
    localStorage.setItem('account', '');
    localStorage.setItem('jwtToken', '');
  }
};
